( function ( _s ) {
	let scrolled = false;
	let element = false;
	let _element = false;

	function smoothScrollToHash() {
		if ( _element.length ) {
			if ( ! scrolled ) {
				const currentBodyTopPadding = parseInt(
					window.getRootProperty( '--body-top-padding' )
				);
				const elementTop = _s( element ).offset().top;
				const navbarOffset = elementTop < window.scrollY ? currentBodyTopPadding : 0;
				const elementHasPadding = parseInt( _element.css( 'paddingTop' ) );

				let offset = 0;

				if ( ! elementHasPadding ) {
					offset = 60;
				}

				window.scrollTo( {
					top: parseInt( elementTop - offset - navbarOffset ),
					behavior: 'smooth',
				} );

				scrolled = true;
			}
		}
	}

	if ( window.location.hash ) {
		const originalHash = window.location.hash;
		const hash = originalHash.substring( 1 );

		element = document.getElementById( hash );
		_element = _s( element );

		if ( _element.length ) {
			_s( document ).ready( () => {
				const resizeCallback = () => {
					smoothScrollToHash();
				};

				const debouncedResizeCallback = window.debounce( resizeCallback, 1000 );

				const resizeObserver = new ResizeObserver( () => {
					debouncedResizeCallback();
				} );

				resizeObserver.observe( _s( 'body' ).firstElement() );
			} );
		}
	}
} )( window._s );
